/* cb-collections-index.js - filteren, sorteren, A-Z en inklappen op /collections
 *
 * Hoort bij sections/cb-collections-index.liquid. De server rendert elke
 * collectielink; dit script verbergt en herschikt alleen. Draait het niet, dan
 * staat de hele lijst er nog steeds, alleen ongefilterd. Daarom staan de
 * A-Z-rij en de inklapknoppen in de HTML op `hidden`: die hebben zonder script
 * geen betekenis.
 */
(function () {
  var root = document.querySelector('[data-cb-collections]');
  if (!root) { return; }

  var search = root.querySelector('[data-cb-search]');
  var letterBar = root.querySelector('[data-cb-letters]');
  var result = root.querySelector('[data-cb-result]');
  var viewButtons = Array.prototype.slice.call(root.querySelectorAll('[data-cb-view]'));
  var sortButtons = Array.prototype.slice.call(root.querySelectorAll('[data-cb-sort]'));

  var state = { query: '', view: 'all', letter: '*', sort: 'az' };

  /* Onder 768px staat er geen A-Z-index; op 375px zou een rij van 27 knoppen de
     halve pagina pakken. Dat is dezelfde grens als in de CSS. */
  var wide = window.matchMedia('(min-width: 768px)');

  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-cb-group]')).map(function (el) {
    var cards = Array.prototype.slice.call(el.querySelectorAll('[data-cb-card]')).map(function (card) {
      return {
        el: card,
        name: card.getAttribute('data-name') || '',
        count: parseInt(card.getAttribute('data-count'), 10) || 0,
        letter: card.getAttribute('data-letter') || ''
      };
    });
    return {
      id: el.getAttribute('data-cb-group'),
      el: el,
      grid: el.querySelector('[data-cb-grid]'),
      empty: el.querySelector('[data-cb-empty]'),
      more: el.querySelector('[data-cb-more]'),
      countEl: el.querySelector('[data-cb-group-count]'),
      cards: cards,
      expanded: false
    };
  });

  function limit() {
    return wide.matches ? 20 : 10;
  }

  function matches(card) {
    if (state.query && card.name.indexOf(state.query) === -1) { return false; }
    if (state.letter !== '*' && card.letter !== state.letter) { return false; }
    return true;
  }

  function compare(a, b) {
    if (state.sort === 'za') { return b.name.localeCompare(a.name, 'nl'); }
    if (state.sort === 'count') { return b.count - a.count; }
    return a.name.localeCompare(b.name, 'nl');
  }

  function thousands(value) {
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function render() {
    var total = 0;

    groups.forEach(function (group) {
      var visible = group.cards.filter(matches).sort(compare);
      var shown = group.expanded ? visible : visible.slice(0, limit());
      var hidden = state.view !== 'all' && state.view !== group.id;

      group.el.hidden = hidden;
      if (!hidden) { total += visible.length; }

      /* Herschikken en verbergen in een keer: de zichtbare kaarten gaan in
         volgorde achter elkaar terug in het raster, de rest gaat op hidden. */
      var frag = document.createDocumentFragment();
      shown.forEach(function (card) {
        card.el.hidden = false;
        frag.appendChild(card.el);
      });
      group.cards.forEach(function (card) {
        if (shown.indexOf(card) === -1) { card.el.hidden = true; }
      });
      group.grid.appendChild(frag);

      if (group.countEl) { group.countEl.textContent = thousands(visible.length); }
      if (group.empty) { group.empty.hidden = visible.length > 0; }

      if (group.more) {
        if (visible.length > limit()) {
          group.more.hidden = false;
          group.more.textContent = group.expanded
            ? group.more.getAttribute('data-label-less')
            : group.more.getAttribute('data-label-more') + ' ' + thousands(visible.length) + ' ' +
              (visible.length === 1
                ? group.more.getAttribute('data-word-one')
                : group.more.getAttribute('data-word-many'));
        } else {
          group.more.hidden = true;
          group.expanded = false;
        }
      }
    });

    if (result) {
      var word = total === 1
        ? result.getAttribute('data-word-one')
        : result.getAttribute('data-word-many');
      var suffix = state.query || state.letter !== '*'
        ? ' ' + result.getAttribute('data-word-found')
        : '';
      result.textContent = thousands(total) + ' ' + word + suffix;
    }
  }

  function buildLetters() {
    if (!letterBar || !wide.matches) { return; }

    var present = {};
    groups.forEach(function (group) {
      group.cards.forEach(function (card) {
        if (/^[A-Z]$/.test(card.letter)) { present[card.letter] = true; }
      });
    });

    'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (letter) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cb-cols__letter' + (present[letter] ? '' : ' is-empty');
      button.setAttribute('data-letter', letter);
      button.textContent = letter;
      if (!present[letter]) { button.disabled = true; }
      letterBar.appendChild(button);
    });

    letterBar.hidden = false;

    letterBar.addEventListener('click', function (event) {
      var button = event.target.closest('[data-letter]');
      if (!button || button.disabled) { return; }
      var value = button.getAttribute('data-letter');
      /* Nog eens op de actieve letter klikken zet hem terug op alles. */
      state.letter = state.letter === value ? '*' : value;
      Array.prototype.forEach.call(letterBar.children, function (child) {
        child.classList.toggle('is-on', child.getAttribute('data-letter') === state.letter);
      });
      render();
    });
  }

  search && search.addEventListener('input', function () {
    state.query = search.value.trim().toLowerCase();
    render();
  });

  viewButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      state.view = button.getAttribute('data-cb-view');
      viewButtons.forEach(function (other) { other.classList.toggle('is-on', other === button); });
      render();
    });
  });

  sortButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      state.sort = button.getAttribute('data-cb-sort');
      sortButtons.forEach(function (other) { other.classList.toggle('is-on', other === button); });
      render();
    });
  });

  groups.forEach(function (group) {
    if (!group.more) { return; }
    group.more.addEventListener('click', function () {
      group.expanded = !group.expanded;
      render();
      if (!group.expanded) { group.el.scrollIntoView({ block: 'start' }); }
    });
  });

  /* De grens tussen 10 en 20 kaarten verschuift met de breedte, dus opnieuw
     tekenen zodra hij overgaat. */
  var onChange = function () { render(); };
  if (wide.addEventListener) { wide.addEventListener('change', onChange); }
  else if (wide.addListener) { wide.addListener(onChange); }

  buildLetters();
  render();
})();
